import React from "react";
import { AbsoluteFill, useCurrentFrame } from "remotion";
import {
  SafeZoneOverlay,
  AnimatedCounter,
  ShimmerText,
  KineticBadge,
  BentoItem,
  SlidingHighlight,
} from "./components/elements";

export const ElementLibraryShowcase: React.FC = () => {
  const frame = useCurrentFrame();

  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#070908",
        color: "#ffffff",
        fontFamily: "'Inter', -apple-system, sans-serif",
        boxSizing: "border-box",
      }}
    >
      {/* Interactive Safe Zone Overlay */}
      <SafeZoneOverlay visible={true} opacity={0.5} />

      {/* Main Content inside Safe Box */}
      <div
        style={{
          position: "absolute",
          top: "220px",
          left: "80px",
          right: "140px",
          bottom: "440px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          zIndex: 10,
        }}
      >
        {/* Title & Badge */}
        <div>
          <KineticBadge text="Remotion Element Library • Studio Preview" />
          <div
            style={{
              fontSize: "64px",
              fontWeight: 800,
              lineHeight: 1.05,
              marginTop: "20px",
              letterSpacing: "-0.03em",
            }}
          >
            Modular UI <ShimmerText>Elements</ShimmerText>
          </div>
          <div style={{ fontSize: "20px", color: "#84968d", marginTop: "8px" }}>
            Library komponen siap pakai untuk produksi video instan.
          </div>
        </div>

        {/* Bento Showcase Grid */}
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          {/* Item 1: Counter */}
          <BentoItem delay={10} active={frame > 30 && frame < 90}>
            <div style={{ fontSize: "14px", color: "#e8f36e", fontWeight: 700, textTransform: "uppercase" }}>
              Component: AnimatedCounter
            </div>
            <div style={{ fontSize: "48px", fontWeight: 900, color: "#ffffff", marginTop: "4px" }}>
              <AnimatedCounter from={0} to={15000} durationInFrames={45} prefix="Rp " suffix=",00" />
            </div>
          </BentoItem>

          {/* Item 2: Sliding Highlight */}
          <BentoItem delay={20} active={frame >= 90 && frame < 150}>
            <div style={{ fontSize: "14px", color: "#ffffff", fontWeight: 700, textTransform: "uppercase" }}>
              Component: SlidingHighlight
            </div>
            <div style={{ fontSize: "28px", fontWeight: 700, marginTop: "8px", lineHeight: 1.3 }}>
              Dapatkan diskon spesial di{" "}
              <SlidingHighlight delay={35} durationInFrames={20}>
                Pertengahan Bulan
              </SlidingHighlight>
            </div>
          </BentoItem>

          {/* Item 3: Shimmer Text & Badge */}
          <BentoItem delay={30} active={frame >= 150}>
            <div style={{ fontSize: "14px", color: "#e8f36e", fontWeight: 700, textTransform: "uppercase" }}>
              Component: ShimmerText & Pulse
            </div>
            <div style={{ fontSize: "32px", fontWeight: 800, marginTop: "6px" }}>
              <ShimmerText shimmerColor="#e8f36e">JADWAL FLASH SALE RESMI</ShimmerText>
            </div>
          </BentoItem>
        </div>

        {/* Footer info */}
        <div
          style={{
            borderTop: "1px solid rgba(255,255,255,0.1)",
            paddingTop: "14px",
            fontSize: "16px",
            color: "#84968d",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>Pantau safe zone border (merah/hijau) di Studio</div>
          <div style={{ color: "#e8f36e", fontWeight: 700 }}>STUDIO.KYUIDN.CLOUD</div>
        </div>
      </div>
    </AbsoluteFill>
  );
};
